var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "ci-user-profile-advisory-services ci-card ci-section ci-content-padding",
    },
    [
      _c("div", { staticClass: "d-flex mb-2" }, [
        _c("div", { staticClass: "flex-grow-1" }, [
          _c("h3", {
            staticClass: "h5 mb-0",
            domProps: {
              textContent: _vm._s(
                _vm.$t("ui.components.users.profile.advisory_services.title")
              ),
            },
          }),
        ]),
      ]),
      _vm.items.length > 0
        ? [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-wrap justify-content-start align-items-center",
              },
              _vm._l(_vm.items, function (service, index) {
                return _c("ci-tag", {
                  key: service.id,
                  staticClass: "ci-tag font-weight-semi mr-2 my-1",
                  attrs: {
                    "tag-name": service.title,
                    tag: service,
                    tagId: service.id,
                    variant: "link",
                    styleVariant: "outline-primary",
                    searchUrl: _vm.searchPath(service.title),
                  },
                })
              }),
              1
            ),
          ]
        : [
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "ui.components.users.profile.advisory_services.empty_state"
                  )
                ),
              },
            }),
            _c(
              "div",
              { staticClass: "row flex-center" },
              [
                _c("ci-button", {
                  attrs: {
                    icon: "mdi-plus",
                    label: _vm.$t(
                      "ui.components.users.profile.advisory_services.action"
                    ),
                    to: {
                      name: _vm.$routes.USERS_EDIT,
                      params: { id: _vm.slug },
                      hash: "#areaofservices",
                    },
                    variant: "outline-primary",
                  },
                }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }